export default __webpack_public_path__ + "static/media/front-desk.1b71e23b.jpg";